import React, { useState, useEffect } from "react";
// import { useWindowSize } from "./useWindowSize";
import {
  // BrowserView,
  // MobileView,
  // isBrowser,
  isMobile,
} from "react-device-detect";

export function useIsMobile() {
  //   const [isMobile, setIsMobile] = useState(true);
  //   const thisSize = useWindowSize();
  //   const [loading, setLoading] = useState(true);
  //   alert(isMobile);

  //   useEffect(() => {
  //     if (thisSize.width < 767) {
  //       setIsMobile(true);
  //     } else {
  //       setIsMobile(false);
  //     }
  //   }, [thisSize]);
  //   return isMobile;

  const [width, setWidth] = useState(window.innerWidth);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const isMobile = width <= 768;

  return isMobile;
}
